<template>
  <div>
    <h1>لاگ</h1>
    <div class="row mx-auto justify-content-center my-2">

      <b-form-input
          @keypress.enter.prevent="search"
          v-model="searchWords"
          placeholder="جستجو"
          class="col-6 "
      ></b-form-input>
      <b-button
          @click="search"
          variant="primary"
          class="col-lg-1 col-md-2 col-3 mx-2"
      >
        جستجو
      </b-button>
    </div>


    <!-- جدول برای نمایش داده‌ها -->
    <table class="table table-hover table-striped table-bordered table-responsive-md table-responsive-sm text-wrap">
      <thead>
      <tr>
        <th>آیدی</th>
        <th>تاریخ ساخت</th>
        <th>آی پی</th>
        <th>کاربر</th>
        <th>متد</th>
        <th>پارامتر ها</th>
      </tr>
      </thead>
      <tbody>
      <!-- استفاده از v-for برای تکرار داده‌ها در جدول -->
      <tr v-for="log in logs" :key="log.id">
        <td>{{ log.id }}</td>
        <td>{{ log.created_at }}</td>
        <td>{{ log.ip_address }}</td>
        <td>{{ userManager(log.user) }}</td>
        <td>{{ log.method }}</td>
        <td>{{ log.parameters }}</td>


      </tr>
      </tbody>
    </table>


    <b-row class="pt-3 mt-3">
      <pagination :meta="pagination" :on-change-page="changeProductsPage"/>
    </b-row>
  </div>

</template>

<script>

import pagination from "@/plugin/components/dashboard/Pagination.vue";

export default {
  name: "Logs",
  components: {pagination,},
  data() {
    return {
      logs: [],
      pagination: [],
      searchWords: '',
    };
  },
  computed: {},
  methods: {
    async getLogs(page = 1) {
      if (this.$route.query.page !== undefined) {
        page = this.$route.query.page;
      }
      const result = await this.$store.dispatch("Log/getLogs", page);
      let data = result.data.data;
      this.logs = data.data;
      this.pagination = data.meta;

    },
    changeProductsPage(page) {
      const currentRouteQuery = this.$route.query
      this.$router.push({name: this.$route.name, query: {...currentRouteQuery, ...{page: page}}})
      this.getLogs(page)
    },
    async search() {
      this.$store.commit('Log/setFilters', {key: 'search', value: this.searchWords})
      await this.getLogs(); // دریافت داده‌ها پس از بارگذاری کامپوننت
    },
    userManager(user){
      if(user == null){
        return ''
      }
      return  `${user.name} ${user.last_name}`
    }
  },
  async mounted() {
    await this.getLogs(); // دریافت داده‌ها پس از بارگذاری کامپوننت
  },
  destroyed() {
    this.$store.commit('Log/setFilters', {key: 'search', value: ''})
  }
};

</script>

<style scoped>

</style>
